export default function Terms() {
  return (
    <div className="min-h-screen bg-white py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="font-heading font-bold text-section text-neutral-800 mb-8">
          Términos y Condiciones de Uso
        </h1>

        <div className="prose prose-neutral max-w-none">
          <p className="lead text-lg text-neutral-600 mb-6">
            Al acceder y utilizar esta plataforma, aceptas estar sujeto a estos términos y
            condiciones de uso.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">1. Aceptación de Términos</h2>
          <p>
            El uso de la plataforma Learn to Lead Change implica la aceptación total y sin reservas
            de todos los términos y condiciones aquí establecidos. Si no estás de acuerdo con estos
            términos, no debes utilizar esta plataforma.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">2. Registro de Usuario</h2>
          <ul>
            <li>Debes ser mayor de 18 años para registrarte</li>
            <li>Debes proporcionar información veraz y actualizada</li>
            <li>Eres responsable de mantener la confidencialidad de tu contraseña</li>
            <li>No puedes transferir tu cuenta a terceros</li>
            <li>Nos reservamos el derecho de suspender cuentas que incumplan estos términos</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">3. Uso Aceptable</h2>
          <p>Te comprometes a:</p>
          <ul>
            <li>Usar la plataforma únicamente con fines legales y educativos</li>
            <li>No publicar contenido ofensivo, difamatorio o ilegal</li>
            <li>Respetar los derechos de propiedad intelectual</li>
            <li>No interferir con el funcionamiento de la plataforma</li>
            <li>No utilizar la plataforma para spam o publicidad no autorizada</li>
            <li>Mantener un comportamiento respetuoso hacia otros usuarios</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">4. Contenido de Usuario</h2>
          <p>
            Al publicar contenido en la plataforma (comentarios, posts en foros, etc.):
          </p>
          <ul>
            <li>Conservas la propiedad de tu contenido</li>
            <li>Nos otorgas una licencia para usar, mostrar y distribuir tu contenido en la plataforma</li>
            <li>Garantizas que tienes derecho a publicar ese contenido</li>
            <li>Aceptas que podemos moderar o eliminar contenido inapropiado</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">5. Contenido Educativo</h2>
          <ul>
            <li>Los cursos son para uso personal y educativo</li>
            <li>No puedes redistribuir o vender el contenido de los cursos</li>
            <li>Los certificados emitidos son válidos para fines no oficiales</li>
            <li>El contenido se proporciona "tal como está" sin garantías de exactitud absoluta</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            6. Participación en Campañas
          </h2>
          <ul>
            <li>Al firmar una campaña, tu nombre puede ser compartido con las autoridades pertinentes</li>
            <li>No somos responsables del resultado de las campañas</li>
            <li>Verificamos que las campañas sean legales, pero no garantizamos su exactitud</li>
            <li>Tu participación es voluntaria y bajo tu propia responsabilidad</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            7. Propiedad Intelectual
          </h2>
          <p>
            Todo el contenido de la plataforma (textos, gráficos, logos, iconos, imágenes, videos)
            está protegido por derechos de autor. Los contenidos educativos están bajo licencia
            Creative Commons BY-NC-SA 4.0.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            8. Limitación de Responsabilidad
          </h2>
          <p>
            Learn to Lead Change no será responsable de:
          </p>
          <ul>
            <li>Daños directos, indirectos o consecuentes derivados del uso de la plataforma</li>
            <li>Errores u omisiones en el contenido educativo</li>
            <li>Interrupciones del servicio</li>
            <li>Pérdida de datos</li>
            <li>Acciones de terceros (campañas organizadas por otros usuarios)</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">9. Modificaciones</h2>
          <p>
            Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios
            entrarán en vigor inmediatamente después de su publicación. Es tu responsabilidad
            revisar periódicamente estos términos.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">10. Terminación</h2>
          <p>
            Podemos suspender o terminar tu acceso a la plataforma en cualquier momento, con o sin
            previo aviso, por incumplimiento de estos términos o por cualquier otra razón que
            consideremos apropiada.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            11. Ley Aplicable y Jurisdicción
          </h2>
          <p>
            Estos términos se rigen por la legislación española. Para la resolución de cualquier
            controversia, las partes se someten a los juzgados y tribunales de Madrid, renunciando
            expresamente a cualquier otro fuero que pudiera corresponderles.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">12. Contacto</h2>
          <p>
            Para cualquier pregunta sobre estos términos:
            <br />
            Email: legal@learnleadchange.org
            <br />
            Dirección: [Dirección completa]
          </p>

          <div className="bg-neutral-50 p-4 rounded-lg mt-8">
            <p className="text-sm text-neutral-600">
              Última actualización: Enero 2025
              <br />
              Versión: 1.0
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
